import React from "react";
import { useSpring, animated } from "@react-spring/web";
import { classNames } from "@greeter/util";
import css from "./LoadingStage.module.scss";
import { SlideBox } from "../SlideBox";

export type LoadingStageProps = {
  text?: string;
  className?: string;
};

export const LoadingStage: React.FC<LoadingStageProps> = ({
  text = "Godkend",
  className,
}) => {
  const props = useSpring({
    from: { width: "30%", color: "black" },
    to: { width: "100%", color: "rgba(255, 255, 255, 0)" },
  });

  return (
    <SlideBox className={css.SlideBox}>
      <animated.button style={props} {...classNames(css.btnGrow, className)}>
        {text}
      </animated.button>
    </SlideBox>
  );
};
